/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_UpdatedInputs */

const en_admin_posts_updated = /** @type {(inputs: Admin_Posts_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post updated`)
};

const zh_admin_posts_updated = /** @type {(inputs: Admin_Posts_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文章已更新`)
};

/**
* | output |
* | --- |
* | "Post updated" |
*
* @param {Admin_Posts_UpdatedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_posts_updated = /** @type {((inputs?: Admin_Posts_UpdatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_UpdatedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_posts_updated(inputs)
	return zh_admin_posts_updated(inputs)
});
export { admin_posts_updated as "admin.posts.updated" }